import "./App.css";
import { Route, Routes } from "react-router-dom";
import { AutoRouteList, RouteList } from "./routes/Routes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { toursThank } from "./store/features/toursSlice";
import { useAppDispatch } from "./store/app/store";
import { PlacesList } from "./store/features/placesListSlice";
import { getallBundlesThank } from "./store/features/getBundlesSlice";
import setUpInterceptor from "./services/Intercepter";
function App() {
  const counter = useSelector((state: any) => state.counter);
  const isAuthenticate = counter?.adminDetails?.uid;

  const dispatch: any = useAppDispatch();

  // On mount (including refresh), re-initialize the axios interceptor
  // with the persisted auth token so API calls don't fail with 401.
  useEffect(() => {
    if (isAuthenticate) {
      setUpInterceptor(isAuthenticate);
    }
    dispatch(toursThank());
    dispatch(PlacesList());
    dispatch(getallBundlesThank());
  }, []);

  useEffect(()=> {
    if (isAuthenticate) {
      localStorage.setItem("authToken", isAuthenticate);
    } else {
      localStorage.removeItem("authToken")
    }
  }, [isAuthenticate])

  // Auth routing is handled by the conditional RouteList render below.
  // No manual route guard needed — React Router handles unknown paths.
  return (
    <>
      {!isAuthenticate ? (
        <Routes>
          {AutoRouteList.map((elm: any, idx: number) => (
            <Route key={idx} path={elm.path} element={elm.component} />
          ))}
        </Routes>
      ) : (
        <Routes>
          {RouteList.map((elm: any, idx: number) => (
            <Route key={idx} path={elm.path} element={elm.component} />
          ))}
        </Routes>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
export default App;
